import * as React from 'react';
import { view } from '@sail/ui';
import { createViewConfig } from '@sail/engine';
import { styles, flagCoordinates } from './FlagIconStyles';
export const FlagIconConfig = createViewConfig({
    props: {},
    name: 'FlagIcon'
});
/**
 * Renders a flag icon for a given country code
 */ export const FlagIcon = FlagIconConfig.createView(({ country, ...rest })=>{
    return /*#__PURE__*/ React.createElement(view.img, {
        src: "https://images.ctfassets.net/fzn2n1nzq965/5JNjy04LAsNrA6xBh7Ao6z/0627f061f30ba1e46b9f2f8e2a0e48c1/flagIcons.svg",
        alt: `Flag of ${country}`,
        loading: "lazy",
        uses: [
            styles.icon,
            flagCoordinates[country]
        ],
        ...rest
    });
});

//# sourceMappingURL=FlagIcon.js.map